import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactCardFlip from "react-card-flip";
import Hidden from "@material-ui/core/Hidden";

export const FlashcardComponent = ({
  dataSource = [],
  flipDirection,
  reportShared,
  onSound,
  onChange,
  onFinish,
  onCorrect,
  onMistake,
  onStart,
  onRepeatSet,
}) => {
  const [step, setStep] = useState(1);
  const [side, setSide] = useState("front");
  const [isFinish, setIsFinish] = useState(false);

  const handleChangeSide = () => {
    const newSide = side === "front" ? "back" : "front";
    setSide(newSide);
    onChange(step, newSide);
  };

  // const handlePrev = () => {
  //   const prevStep = step > 1 ? step - 1 : 1;
  //   setSide("front");
  //   setStep(prevStep);
  //   onChange(prevStep, "front");
  // };

  const handleCorrect = (data) => {
    onCorrect({ ...data });
    handleNext();
  };

  const handleMistake = (data) => {
    onMistake({ ...data });
    setSide("back");
    setTimeout(() => {
      setSide("front");
      handleNext();
    }, 1500);
  };

  const handleNext = () => {
    const max = dataSource.length;
    const isFinish = step + 1 > max;
    setIsFinish(isFinish);
    const nextStep = step < max ? step + 1 : max;
    setSide("front");
    setTimeout(
      () => {
        setStep(nextStep);
        onChange(nextStep, "front");

        if (isFinish) {
          onFinish();
        }
      },
      side === "back" ? 250 : 0
    );
  };

  const handleSpeaker = () => {
    const text = dataSource[step - 1][side].text;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "es-CO";
    window.speechSynthesis.speak(utterance);
    onSound(text);
  };

  const handleStartNewSet = () => {
    onStart();
    setStep(1);
    setSide("front");
    setIsFinish(false);
  };

  const handleStartOver = () => {
    onRepeatSet();
    setStep(1);
    setSide("front");
    setIsFinish(false);
  };

  return (
    <div style={Styles.container}>
      {isFinish ? (
        <div style={Styles.finishContainer}>
          <h2 style={{ marginTop: 0, marginBottom: 10 }}>Nice work!</h2>
          <p style={{ margin: 0 }}>
            You just studied {dataSource.length} terms!
          </p>
          <button style={Styles.startOverButton} onClick={handleStartNewSet}>
            Study new terms
          </button>
          <button style={Styles.startOverButton} onClick={handleStartOver}>
            Repeat this set
          </button>
          {/* <button
            style={
              reportShared
                ? Styles.startOverButtonDisabled
                : Styles.startOverButton
            }
            onClick={onFinish}
            disabled={reportShared}
          >
            Share your results with Julieth
          </button> */}
        </div>
      ) : (
        <div>
          <div style={Styles.numbersContainer}>
            <div style={Styles.number}>{`${step}/${dataSource?.length}`}</div>
          </div>
          <div style={Styles.progress}>
            <div style={Styles.bar}>
              <span
                style={{
                  ...Styles.complete,
                  width: `${(step / dataSource.length) * 100}%`,
                }}
              ></span>
            </div>
          </div>
          <div style={Styles.card}>
            <img
              alt="volume"
              style={Styles.soundButton}
              src="https://www.flaticon.com/svg/static/icons/svg/786/786272.svg"
              onClick={handleSpeaker}
            />
            <div onClick={handleChangeSide} style={{ height: "100%" }}>
              <ReactCardFlip
                containerStyle={{ height: "100%" }}
                isFlipped={side === "back"}
                flipDirection={flipDirection}
              >
                <div style={Styles.cardContent}>
                  {dataSource[step - 1]?.front?.image && (
                    <img
                      alt="term"
                      width="40%"
                      height="40%"
                      src={dataSource[step - 1]?.front?.image}
                    />
                  )}
                  <p>{dataSource[step - 1]?.front?.text}</p>
                </div>
                <div style={Styles.cardContent}>
                  {dataSource[step - 1]?.back?.image && (
                    <img
                      alt="term"
                      width="40%"
                      height="40%"
                      src={dataSource[step - 1]?.back?.image}
                    />
                  )}
                  <p>{dataSource[step - 1]?.back?.text}</p>
                </div>
              </ReactCardFlip>
            </div>
          </div>
          <div style={Styles.reportButtons}>
            <button
              style={Styles.mistakeButton}
              onClick={() =>
                handleMistake({
                  back: dataSource[step - 1]?.back?.text,
                  front: dataSource[step - 1]?.front?.text,
                })
              }
            >
              <Hidden smDown>No recuerdo </Hidden>
              <span role="img" aria-label="oops">
                😅
              </span>
            </button>
            <button
              style={Styles.correctButton}
              onClick={() =>
                handleCorrect({
                  back: dataSource[step - 1]?.back?.text,
                  front: dataSource[step - 1]?.front?.text,
                })
              }
            >
              <Hidden smDown>Recuerdo </Hidden>
              <span role="img" aria-label="yes">
                👍
              </span>
            </button>
          </div>
          {/* <div style={Styles.navigation}>
            <div style={Styles.prevButton} onClick={handlePrev}>
              <img
                width="100%"
                height="100%"
                src="https://www.flaticon.com/svg/static/icons/svg/318/318276.svg"
              />
            </div>
            <div style={Styles.nextButton} onClick={handleNext}>
              <img
                width="100%"
                height="100%"
                src="https://www.flaticon.com/svg/static/icons/svg/467/467152.svg"
              />
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

FlashcardComponent.propTypes = {
  dataSource: PropTypes.array.isRequired,
  flipDirection: PropTypes.string,
  reportShared: PropTypes.bool,
  onChange: PropTypes.func,
  onSound: PropTypes.func,
  onFinish: PropTypes.func,
  onCorrect: PropTypes.func,
  onMistake: PropTypes.func,
};

FlashcardComponent.defaultProps = {
  flipDirection: "vertical",
  reportShared: false,
  onChange: (step, size) => {},
  onSound: (text) => {},
  onFinish: () => {},
  onCorrect: () => {},
  onMistake: () => {},
  onStart: () => {},
  onRepeatSet: () => {},
};

const Styles = {
  container: {
    backgroundColor: "#f6f7fb",
  },
  numbersContainer: {
    backgroundColor: "#fff",
  },
  progress: {
    backgroundColor: "#ffffff",
    height: 45,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  bar: {
    display: "flex",
    flex: 3,
    backgroundColor: "#c5cfe8",
    height: "0.75rem",
    position: "relative",
  },
  complete: {
    backgroundColor: "#4257b2",
    bottom: 0,
    display: "block",
    height: "0.75rem",
    left: 0,
    maxWidth: "100%",
    position: "absolute",
    top: 0,
    transition: "all .12s cubic-bezier(.47,0,.745,.715)",
  },
  number: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    fontSize: "1rem",
    letterSpacing: "0.0625rem",
    fontWeight: 600,
  },
  card: {
    height: 350,
    padding: 16,
    position: "relative",
  },
  cardContent: {
    backgroundColor: "#ffffff",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontSize: "1.5rem",
    cursor: "pointer",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  },
  soundButton: {
    position: "absolute",
    zIndex: 999,
    width: 25,
    height: 25,
    right: 26,
    top: 26,
    cursor: "pointer",
  },
  navigation: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 16,
  },
  reportButtons: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: 16,
  },
  prevButton: {
    width: 30,
    height: 30,
    marginLeft: 16,
    backgroundColor: "#ffffff",
    borderRadius: "50%",
  },
  nextButton: {
    width: 30,
    height: 30,
    marginRight: 16,
    backgroundColor: "#ffffff",
    borderRadius: "50%",
  },
  finishContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",
  },
  startOverButton: {
    backgroundColor: "#4257b2",
    width: "60%",
    height: "50px",
    border: "none",
    borderRadius: "5px",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "16px",
    marginTop: 30,
    cursor: "pointer",
  },
  // startOverButtonDisabled: {
  //   backgroundColor: "#a2a5b0",
  //   width: "60%",
  //   height: "50px",
  //   border: "none",
  //   borderRadius: "5px",
  //   color: "#ffffff",
  //   fontWeight: "bold",
  //   fontSize: "16px",
  //   marginTop: 30,
  // },
  mistakeButton: {
    backgroundColor: "#ffc107",
    width: "30%",
    height: "50px",
    border: "none",
    borderRadius: "5px",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "1.5rem",
    margin: 15,
    cursor: "pointer",
  },
  correctButton: {
    backgroundColor: "#28a745",
    width: "30%",
    height: "50px",
    border: "none",
    borderRadius: "5px",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "1.5rem",
    margin: 15,
    cursor: "pointer",
  },
  helper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "0.9rem",
    color: "#222",
  },
};
